export default __webpack_public_path__ + "static/media/Integrationicon.445746cf.svg";